import React, { PureComponent } from "react";
import ReactWOW from "react-wow";
import { $t } from '@/modules/i18n';

class Logo extends PureComponent {
  render() {
    const { isShopee, className, image } = this.props
    const name = $t(this.props.name);
    const imgUrl = image ? require(`@/assets/images/partners/${image}`) : '';
    return (
      <ReactWOW animation="fadeInUp" delay="0.1s">
        <div className={`col-6 ${isShopee ? 'col-md-4 shopee' : 'col-md-3 logo'} ${className || ""}`}>
          <a
            href={this.props.link}
            target="_blank"
            rel="noopener noreferrer"
            className="link"
          >
            {
              image ? (
                <img src={imgUrl} alt={name} className={"img-logo " + (className || "")} />
              ) : (
                <p className="no-logo">{name}</p>
              )
            }
            <p className="name">{name}</p>
          </a>
        </div>
      </ReactWOW>
    );
  }
}

const Partners = ({ message }) => message ? (
  <section id="partners" className="white">
    <h2 className="section-title">{$t(message.title)}</h2>
    <div className="container">
      {
        message.sections.map(section => 
          <div key={section.title}>
            <h2 className="title">{$t(section.title)}</h2>
            <div className={`row ${section.justifyCenter ? 'justify-content-center' : ''}`}>
              {
                section.logos.map(logo =>
                  <Logo
                    key={logo.name}
                    name={logo.name}
                    image={logo.image}
                    link={logo.link}
                    className={logo.className}
                    isShopee={logo.isShopee}
                  />
                )
              }
            </div>
          </div>
        )
      }
    </div>
  </section>
) : null;

export default Partners;
